/* eslint-disable no-console,no-undef, camelcase, no-constant-condition */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { toast } from "react-toastify";
import {
  getOrientation,
  resetOrientation,
  checkImage,
  fetchApi,
} from "../../../utils/methods";
import { imageErrorMessage, ImageUrl } from "../../../utils/constants";
import { withTranslation } from "react-i18next";
import {
  Layout,
  Container,
  InputContainer,
  StyledInputV2,
  StyledLabel,
  ButtonContainer,
  EditorContainer
} from "../../CreateEvent/style";
import StepsHeading from "./stepNames";
import { Main } from "../../AdminTeamCreation/styles";
import Editor from "../../CKEditor";
import CommonDropdown from "../../common/CommonDropDown/CommonDropdown";
import CommonButton from "../../common/CommonButton/CommonButton";
import { AddIconBranding, AdminCloseIcon, AdminLeftArrowIcon, AdminRightArrowIcon, LaunchIcon,/* RecognitionBoldPencilIcon,*/ RecognitionCloseIcon, RecognitionTickIcon } from "../../../utils/icons";
import { AddCompanyExemplifiesValues, LaunchOrEditCompanyCoreValue } from "../../../redux/constants/apiConstants";
import { Border } from "../../Journeys/styles";
import { withRouter } from 'react-router-dom';
import {/*ShowImage*/ Heading, ButtonWrapper, CircleButton,/* EditButton,*/ VerticalBorder, StyledModalV1, ColorGrid, ColorBox, ModalFooter, IconGrid, IconWrapper} from './styles';
import parse from 'react-html-parser';
import { ManagerIconContainer } from "../../Manager/styles";
import { GetCoreValueIcons } from "../../../redux/constants/apiConstants";
import { CommonButtonPopup } from "../../ReportsV2/styles";
class EditCoreValue extends Component {
  constructor(props) {
    super(props);
    this.state = {
      imgSrc: ImageUrl+"/"+props.history?.location?.state?.image,
      imgSrcOriginal: props.history?.location?.state?.image,
      title: props.history?.location?.state?.title,
      description: props.history?.location?.state?.description?props.history?.location?.state?.description:"",
      imageName: "",
      eventPointKey: props.history?.location?.state?.points,
      eventPointValue: props.history?.location?.state?.points,
      status: props.history?.location?.state?.status,
      recognitionId: props.history?.location?.state?.id,
      recognitionCoreValueId: props.history?.location?.state?.core_value_id,
      selectedColorV1: props.history?.location?.state?.color,
      confirmColorV1:props.history?.location?.state?.color,
      selectedIcon :  props.history?.location?.state?.white_icon,
      activeTab: props.history?.location?.state?.activeTab,
      activeTabV: props.history?.location?.state?.activeTabV,
      so:false,
      disableButton:false,
      isModalOpen: false,
      step:1,
      selectedValueIcon:  props.history?.location?.state, 
      coreValueLibraryIcons: [],
      buttonStatus: false,
      showModal: false,
      type: props.history?.location?.state?.type,
      pointsArray: [
        { value: 0, text: "0 Pts" },
        { value: 25, text: "25 Pts" },
        { value: 50, text: "50 Pts" },
        { value: 100, text: "100 Pts" },
        { value: 150, text: "150 Pts" },
        { value: 200, text: "200 Pts" },
        { value: 250, text: "250 Pts" },
        { value: 300, text: "300 Pts" },
        { value: 350, text: "350 Pts" },
        { value: 400, text: "400 Pts" },
        { value: 450, text: "450 Pts" },
        { value: 500, text: "500 Pts" },
        { value: 550, text: "550 Pts" },
        { value: 600, text: "600 Pts" },
        { value: 650, text: "650 Pts" },
        { value: 700, text: "700 Pts" },
        { value: 750, text: "750 Pts" },
        { value: 800, text: "800 Pts" },
        { value: 850, text: "850 Pts" },
        { value: 900, text: "900 Pts" },
        { value: 950, text: "950 Pts" },
        { value: 1000, text: "1000 Pts" }
      ],
      colors: [
        { name: "Red", colorCode: "#EA6149", backgroundImage: "admin-recognition/Red.png" },
        { name: "Blue", colorCode: "#8391D1", backgroundImage: "admin-recognition/Blue.png" },
        { name: "Maroon", colorCode: "#C13D4D", backgroundImage: "admin-recognition/Maroon.png" },
        { name: "Green", colorCode: "#418856", backgroundImage: "admin-recognition/Green.png" },
        { name: "Orange", colorCode: "#CE7841", backgroundImage: "admin-recognition/Orange.png" },
        { name: "Purple", colorCode: "#A65C7C", backgroundImage: "admin-recognition/Purple.png" },
        { name: "Yellow", colorCode: "#A49A4E", backgroundImage: "admin-recognition/Yellow.png" },
        { name: "Teal", colorCode: "#C96BAE", backgroundImage: "admin-recognition/Teal.png" },
      ],
    };
  }

 



  onChange = (e) => {
    let file = e.target.files[0];
    let fileArr = e.target.files;
    if (e.target.files[0]) {
      if (checkImage(fileArr)) {
        if (file?.size / 1000000 <= 20) {
          let reader = new FileReader();
          reader.readAsDataURL(file);
          const array = document
            .getElementById("event-upload-file")
            .value.split("\\");
          reader.onloadend = () => {
            this.setState({
              imgSrc: reader.result,
              imageName: array[array.length - 1],
            });
            getOrientation(file, (or) => {
              resetOrientation([reader.result], or, (baseImage) => {
                this.setState({
                  imgSrc: baseImage,
                });
              });
            });
          };
        } else {
          toast.error("Please select image file less than 20MB");
          document.getElementById("event-upload-file").value = "";
        }
      } else {
        toast.error(imageErrorMessage);
        document.getElementById("event-upload-file").value = "";
      }
    }
  };

  removePhoto = () => {
    this.setState({
      imgSrc: "",
      imageName: "",
    });
  };

  onSelectPoints = (name) => {
    this.setState({
      [name]: name.value,
      eventPointKey: name.key,
      eventPointValue: name.value,
      buttonStatus:false
    });
  };

  saveData = () => {
    const {
      title,
      description,
      eventPointValue,
      selectedValueIcon,
      recognitionCoreValueId,
      recognitionId,
      type
    } = this.state;
    const RecognitionDetails = {
      core_value_id: type === "launch" ? recognitionId  : recognitionCoreValueId,
      points: eventPointValue,
      company_title: title,
      company_description: description,
      white_icon: selectedValueIcon?.white_icon,
    };
    this.setState({buttonStatus:true})
    this.editAndLaunchRecognition(RecognitionDetails);
  };

  PostRecognition = async(payload)=>{
    try{
      const res = await fetchApi(AddCompanyExemplifiesValues, "POST",payload);
      if(res?.data?.message){
        toast.error(res.data.message);
        this.setState({
          buttonStatus: false,
        });
      }else{
        toast.success(res.data[0]);
        this.props.history.push({pathname:`/company/recognition`,state:{activeTab:6}});
      }
    }catch(error){
      toast.error(error)
    }
  }


  getTextLength = (htmlString) => {
    if (!htmlString) return 0;
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = htmlString;
    return tempDiv.textContent.length;
  };

  editAndLaunchRecognition = async(payload)=>{
    const { recognitionId, type } = this.state;
    const companyId= this.props.companyInfo?.id;
    try{
      const res = await fetchApi(`${LaunchOrEditCompanyCoreValue}/${companyId}${type === "launch" ? "" : `/${recognitionId}`}`, "POST",payload);
      if(res?.data?.message){
        toast.error(res.data.message);
        this.setState({
          buttonStatus: false,
        });
      }else{
        toast.success(res.data[0]);
        this.props.history.push({pathname:`/company/recognition`,state:{activeTab:6, activeTabV: type === "launch"?"Inactive": "Active"}});
      }
    }catch(error){
      toast.error(error)
    }
  }

  componentDidMount() {
    this.getCoreValueIcons();
  }

  getCoreValueIcons = async () => {
    let apiUrl = GetCoreValueIcons;
    try {
      const res = await fetchApi(apiUrl, "GET");

      if (res.status === "success") {
        this.setState({ coreValueLibraryIcons: res.data })
      } else {
        toast.error(res.error);
      }
    } catch (error) {
      window.console.error(error);
    }
  }


  togglePopup = () => {
    this.setState((prevState) => ({ isModalOpen: !prevState.isModalOpen }));
  };


  toggleIconPopup = () => {
    this.setState((prevState) => ({ showModal: !prevState.showModal }));
  };

  onChangeDescription = (evt) => {
    const newContent = evt.getData();
    const trimmedString = newContent.replace(/\s|&nbsp;/g, "");
    trimmedString.length === 0 ||
    trimmedString.length === 7 ||
    trimmedString == "<p></p><p></p>"
      ? this.setState({ description: "" })
      : this.setState({ description: newContent },()=>{ try {
        const parsedContent = parse(this.state.description);
        const textLength = parsedContent?.[0]?.props?.children?.[0]?.length || 0;
        
        if (textLength > 300) {
          this.setState({ disableButton: true });
        } else {
          this.setState({ disableButton: false });
        }

      } catch (error) {
        console.error("Parsing error:", error);
      }});
  };

  updateStep = (value) => {
    this.setState({ step: value, buttonClickScrollTop: true });
  };

  nextStep = (value) => {
    this.setState({
      step: value,
      buttonClickScrollTop: true,
      buttonStatus: false,
    });
  };


  onSelectColor = (color) => {
    this.setState({ confirmColorV1: color });
  };

  

  handleSelectedColor = () => {
    this.setState({ isModalOpen: false })
    this.setState({ selectedColorV1:this.state.confirmColorV1 });
  }

  handleCloseModal = () => {
    this.setState({ showModal: false })
  }


  handleCloseColorModal = () => {
    this.setState({ isModalOpen: false })
  }


  handleIconClick = (index, icon) => {
    this.setState({ selectedIcon: index, selectedValueIcon: icon });

  };

  redirect = () => {
    // this.props.history.goBack();
    this.props.history.push({pathname:`/company/recognition`,state:{activeTab:6, activeTabV: this.state.type === "launch"?"Inactive": "Active"}});
  };

  renderHeading = () => (
    <Heading color={"#184A61"}>
      <div id="icon-launch" className="close-icon" onClick={this.redirect}>
        <ManagerIconContainer isWidth={"34px"}>{RecognitionCloseIcon('#F37A65')}</ManagerIconContainer> 
      </div>
      {this.state.type=="launch"?this.props.t("Launch Core Value"):this.props.t("Edit Core Value")}
    </Heading>
  );

  onChangeInput = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  stepOneForm = () => {
    
    const {
      title,
      description,
      step,
      // color,
      showModal,
      coreValueLibraryIcons,
      selectedValueIcon
    } = this.state;
    const { t } = this.props;

    return (
      <Layout>
        <div className="main" >
          {this.renderHeading()}
          <Container color="#005C87">
            <div className="stepsNameHighlight">
              <StepsHeading stepCount={step} type="core-value" padding="20px 20px 265px 20px"/>
            </div>
            <div className="form">
              <div className="formBody">
                <InputContainer>
                  <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px">{this.props.t("Title of the core value")}</StyledLabel>
                  <StyledInputV2
                    placeholder={t("Enter text")}
                    name="title"
                    value={title}
                    maxLength="25"
                    style={{background:"white"}}
                    pColor={"#BDBDBD"}
                    color="#184A61"
                    onChange= { this.onChangeInput}
                    isBorderColor={"1px solid #BDBDBD"}
                  />
                  <div className="count">{title?.length}/25 | C</div>
                </InputContainer>
                <Border style={{background:'rgba(0, 92, 135, 0.10)',margin:'20px 0px'}}/>

                {/* <StyledLabel color={"#184A61"} style={{marginTop:"0px"}}>{this.props.t("Core value icon")}</StyledLabel>
                <ShowImage background={color}>
                  <div className="image">
                    <img alt="profilre-img" src={this.state.imgSrc}></img>
                  </div>
                </ShowImage> */}
                <div style={{ display: "flex", width: "50%" }}>
                  <InputContainer width="auto" style={{ minWidth: "110px" }}>
                    <StyledLabel isFont={"14px"} color={"#184A61"} margin={"0px"}>{this.props.t("Background color")}</StyledLabel>
                    <ButtonWrapper isMargin={"14.5px"}>
                      <CircleButton color={this.state.selectedColorV1}>
                        <div>{!this.state.selectedColorV1 ? AddIconBranding(20, 20) : null}</div>
                      </CircleButton>
                      {/* {this.state.selectedColorV1 && (
                        <EditButton onClick={this.togglePopup}>
                          <div className="editIcon">{RecognitionBoldPencilIcon()}</div>
                        </EditButton>
                      )
                      } */}
                    </ButtonWrapper>
                  </InputContainer>
                  <div style={{
                    display: "flex",
                    alignItems: "center",
                  }}>
                    <VerticalBorder />
                  </div>
                  <InputContainer style={{ minWidth: "28%" }}>
                    <StyledLabel isFont={"14px"} color={"#184A61"} margin={"0px"}>{this.props.t("Core value icon")}</StyledLabel>
                    <ButtonWrapper isMargin={"7.5px"}>
                      <CircleButton color={this.state.selectedColorV1}>
                        {this.state.selectedIcon ? (
                          <div
                            style={{
                              position: 'absolute',
                              left: '28px',
                              top: '55%',
                              transform: 'translateY(-50%)',
                              width: '36px',
                              height: '36px',
                              pointerEvents: 'none',
                            }}><img src={ImageUrl + "/" + selectedValueIcon?.white_icon} width={"24px"} height={"auto"} /></div>
                        ) : AddIconBranding(20, 20)}
                      </CircleButton>
                      {/* {this.state.selectedIcon && (
                        <EditButton  onClick={this.toggleIconPopup}>
                          <div className="editIcon">{RecognitionBoldPencilIcon()}</div>
                        </EditButton>
                      )} */}
                    </ButtonWrapper>
                  </InputContainer>
                </div>


                <StyledModalV1 show={this.state.isModalOpen} onHide={this.handleCloseColorModal} width="800px" height="240px">
                  <div className="modal-content-padding">
                    <div className="header-wrapper">
                      <div className="heading">{t("Choose Background Color For Icon")}</div>
                      <div className="close-icon" onClick={this.handleCloseColorModal}>
                        {AdminCloseIcon()}
                      </div>
                    </div>
                    <Border style={{ background: '#EFEFEF', margin: '16px 0px' }} />
                    <ColorGrid>
                      {this.state.colors.map((color) => (
                        <ColorBox
                          key={color.colorCode}
                          style={{ background: color.colorCode }}
                          onClick={() => this.onSelectColor(color.colorCode)}
                        />
                      ))}
                    </ColorGrid>
                    <Border style={{ background: '#EFEFEF', margin: '16px 0px' }} />
                    <ModalFooter>
                      <button className="confirm-btn" onClick={this.handleSelectedColor}>
                        <div> {("Select Color")}</div>
                        <div className="icon"> {RecognitionTickIcon("white")}</div>
                      </button>
                    </ModalFooter>
                  </div>
                </StyledModalV1>


                {showModal && (

                  <StyledModalV1 isPadding={"0px 16px"} show={showModal} onHide={this.handleCloseModal} width="600px" height="424px">
                    <div className="modal-content-padding">
                      <div className="header-wrapper">
                        <div className="heading">{t("Choose Core Value Icon")}</div>
                        <div className="close-icon" onClick={this.handleCloseModal}>
                          {AdminCloseIcon()}
                        </div>
                      </div>
                      <Border style={{ background: '#EFEFEF', margin: '16px 0px' }} />
                      <IconGrid>
                        {coreValueLibraryIcons?.length > 0 ? (
                          this.state.coreValueLibraryIcons?.map((icon, index) => (
                            <IconWrapper
                              key={index}
                              isSelected={this.state.selectedIcon === index}
                              onClick={() => this.handleIconClick(index, icon)}>
                              <img src={this.state.selectedIcon === index ? ImageUrl + "/" + icon?.white_icon : ImageUrl + "/" + icon?.blue_icon} />
                            </IconWrapper>
                          ))
                        ) : (
                          <p>No icons available</p>
                        )}
                      </IconGrid>
                      <Border style={{ background: '#EFEFEF', margin: '16px 0px' }} />
                      <ModalFooter>
                        <button className="confirm-btn" onClick={this.handleCloseModal}>
                          <div> {("Select Icon")}</div>
                          <div className="icon"> {RecognitionTickIcon("white")}</div>
                        </button>
                      </ModalFooter>
                    </div>
                  </StyledModalV1>
                )}

                <Border style={{background:'rgba(0, 92, 135, 0.10)',margin:'20px 0px'}}/>
                <InputContainer isColorError={parse(description)?.[0]?.props?.children?.[0]?.length>300} >
                  <StyledLabel isFont={"14px"} style={{marginTop:"0px"}} color={"#184A61"}>{this.props.t("About the core value")}</StyledLabel>
                  <EditorContainer>
                    <Editor
                      content={description}
                      onChange={this.onChangeDescription}
                    />
                  </EditorContainer>
                  <div className="char-count">
                    {this.getTextLength(description)}/300 | C
                  </div>
                  {/* <div  className="char-count">{parse(description)?.[0]?.props?.children?.[0]?.length || 0}/300 | C</div> */}
                </InputContainer>
              </div>
            </div>
          </Container>
        </div>
      </Layout>
    );
  };

  stepTwoForm = () => {
    const {
      step,
      eventPointValue,
      pointsArray
    } = this.state;

    return (
      <Layout>
        <div className="main">
          {this.renderHeading()}
          <Container  isHeight="104px" color={"#005c87"}>
            <div className="stepsNameHighlight">
              <StepsHeading stepCount={step} type="core-value" padding="20px 20px 265px 20px"/>
            </div>
            <div className="form">
              {/* <div className="heading">
                <div className="step">{step}</div>
                <div className="headingName">
                  {this.props.t("How would you like to customize your core value?")}
                </div>
              </div> */}
              <div className="formBody">
                <CommonDropdown
                  tileContainerStyle={{ width: "100%",padding:"0px" }}
                  dropdownStyle={{ top: "90px" }}
                  labelText={this.props.t("Core value point")}
                  isRequired={true}
                  dropdownOpen={this.state.so}
                  placeholder={this.props.t("Select Point Value")}
                  title={
                    eventPointValue || eventPointValue == 0  ? eventPointValue+" Points":+"No Points"
                  }
                  id="dropdown-recurring"
                  onClick={() => this.setState({ so: !this.state.so })}
                  data={pointsArray}
                  onSelect={this.onSelectPoints}
                  active={eventPointValue}
                  onSelectParameter={["eventPointValue", "value", "key"]}
                  valueString={"Points"}
                  itemValue={true}
                  valueIndex={1}
                  labelMargin={"0px"}
                  dropIcon={true}
                  fontSize={"14px"}
                />        
              </div>
            </div>
          </Container>
        </div>
      </Layout>
    );
  };

  render() {
    const {
      title,
      imgSrc,
      step,
      buttonStatus,
      type,
      disableButton,
      description
    } = this.state;




    return (
      <React.Fragment>
        {step === 1
          ? this.stepOneForm()
          : step === 2
            ? this.stepTwoForm()
            : null}
        {step === 1 ? (
          <ButtonContainer>
            <Main>
              {/* <CommonButton
                btnType={"squareIcon"}
                onClick={() => this.updateStep(2)}
                disabled={!title ||!imgSrc || disableButton||!description}
                title={this.props.t("Next")}
                styles={{color:"#F37A65",height:"48px",border:"#F37A65",padding:"16px 20px", width:"90px", background:"#F37A65",fontFamily:"Lato",fontSize:"16px",display:'flex'}}
                // nextIcon={AdminRightArrowIcon()}
                nextIcon={disableButton ? AdminRightArrowIcon("#989898"):AdminRightArrowIcon()}
              /> */}
              <CommonButtonPopup height="48px" width="90px" margin="auto 0 auto auto" disabled={!title || !description || disableButton || !imgSrc } onClick={!title || !description || disableButton ?null: () => this.updateStep(2)}>
                   Next
                {!title || !description || disableButton  ? AdminRightArrowIcon("#989898") : AdminRightArrowIcon()}
              </CommonButtonPopup>
            </Main>
          </ButtonContainer>
        ) :
          step === 2 && (
            <ButtonContainer>
              <div className="wrapper">
                <CommonButton
                  btnType={"squareIcon"}
                  styles={{color:"white", fontSize:"16px",textColor:"#184A61",border:"#F37A65",width:"auto", marginLeft:"0px",display:"flex",justifyContent:"center",alignItems:"center"}}
                  onClick={() => this.nextStep(1)}
                  title={this.props.t("Back")}
                  icon={AdminLeftArrowIcon()}
                />
                <CommonButton
                  module="core-value"
                  btnType={"squareIcon"}
                  styles={{color:"#F37A65",display:"flex", width: this.state.type === "launch" ? "118px" : "159px",height:"48px", padding:"16px 20px" ,marginAuto:'auto', border:"#F37A65"}}
                  onClick={!buttonStatus && this.state.eventPointValue !== null ? () => this.saveData():null}
                  coreValueDisabled={buttonStatus || this.state.eventPointValue === null}
                  title={this.props.t(type === "launch"? "Launch" :"Save Changes")}
                  nextIcon={this.state.type == "launch" ? LaunchIcon(this.state.eventPointValue !== null  ? "#F8F8F8" : "#989898") : RecognitionTickIcon(color="white",width="16" ,height="10") }
                />
              </div>
              
            </ButtonContainer>
          )}
      </React.Fragment>
    );
  }
}

EditCoreValue.propTypes = {
  history: PropTypes.object.isRequired,
  role: PropTypes.string.isRequired,
  t: PropTypes.func,
  companyInfo: PropTypes.object
};

export default (withRouter(withTranslation()(EditCoreValue)));
